<template>
  <div class="main-wrapper">
    <div class="header-container">
      <div class="header-left-wrapper">
        <span class="header-left">{{ $t("app.home_title") }} </span>
      </div>

      <div class="header-right-wrapper">
        <div class="header-right-wrapper-item">
          <div class="header-input-item">
            <img src="@img/b-seach.png"
                 style="width:30px;height:30px;"
                 @click="goSearch" />
          </div>

          <div class="header-right-item-right"
               @click="changeText">
            <span class="header-item-text">{{ localeFont }}</span>
            <span class="down-arrow"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="book-list-wrapper">
      <!-- 售賣機位置信息-->
      <div class="location-bg">
        <div>
          <div class="location-title-view location-top-view"
               @click="selectBookLoaction">
            <span v-if="shopId"
                  class="location-title-text">{{ sale_machine_name }}
            </span>
            <span v-else
                  class="location-title-text">{{ $t("app.home_selectSoldMachie") }}
            </span>
            <span class="down-address-arrow"></span>
          </div>

          <div v-if="shopId"
               class="location-title-view location-bottom-view">
            <span class="location-desc-text">{{ $t("app.home_address") }}：</span>
            <span class="location-desc-text">{{ address }}</span>
          </div>
        </div>
      </div>
      <div class="line-view"></div>

       <div v-if="isShowTips" class="announcement-box">
          {{tips_content}}
       </div>

      <!-- 圖書列表  start-->
      <div class="book-list-wrapper">
        <div v-for="(item, index) in arrList"
             :key="index">
          <div class="book-list-wrapper-item"
               @click="openBookDetail(item.itemid)">
            <div class="book-left">
              <van-image width="70px"
                         height="100px"
                         cover
                         :src="item.photo_url" />
            </div>
            <div class="book-right">
              <div class="book-title"
                   v-if="item.kioskrankorder > 0">
                <span style="height: 20px;margin-right:8px;padding:0 5px; text-align: center;line-height: 20px;font-size:10px;color:white;font-wigth:500px;background: linear-gradient(0deg, #269CA8 0%, #6AC6BA 100%);border-radius: 4px;">{{ $t("app.home_lr") }}</span>
              </div>
              <div style="margin-top:3px"
                   :class="item.name.length > 0 ? '' : 'book-title-maxHeight'">
                <span class="book-title-text">{{ item.name }}</span>
              </div>

              <div class="book-desc-wrapper">
                <div class="book-desc-item">
                  <span class="book-desc-item-left">{{ $t("app.home_publisher") }}：</span>
                  <span class="book-desc-item-right">{{ item.publisher }}</span>
                </div>
                <div class="book-desc-item">
                  <span class="book-desc-item-left">{{ $t("app.home_publishlang") }}：</span>
                  <span class="book-desc-item-right">{{ item.publishlang }}
                  </span>
                </div>
                <div class="book-desc-item-last">
                  <div style="display:flex">
                    <span class="book-desc-item-left">{{ $t("app.home_publishdate") }}：</span>
                    <span class="book-desc-item-right">{{ item.publishdate }}
                    </span>
                  </div>
                  <div class="book-desc-item-content-right"
                       v-if="item.epublisher > 0">
                    <span class="book-desc-item-content-right-currency">MOP&nbsp;&nbsp;</span>
                    <span class="book-desc-item-content-right-amount">{{ item.epublisher }}
                    </span>
                  </div>
                  <div v-else>
                    <span class="book-desc-item-content-right-currency">{{ $t("app.home_free") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <van-divider />

          <div v-if="item.quantity <= 0"
               style=" display:flex;justify-content: flex-end;position: absolute;z-index: 99;right:15px;margin-top: -70px;">
            <img v-if="selectIndex == 3"
                 src="@img/ibms_sold_out_p@2x.png"
                 alt=""
                 style="width:80px;height:42px" />
            <img v-if="selectIndex == 2"
                 src="@img/ibms_sold_out_en@2x.png"
                 alt=""
                 style="width:80px;height:42px" />
            <img v-if="selectIndex == 1"
                 src="@img/ibms_sold_out@2x.png"
                 alt=""
                 style="width:80px;height:42px" />
            <img v-if="selectIndex == 0"
                 src="@img/ibms_sold_out@2x.png"
                 alt=""
                 style="width:80px;height:42px" />
          </div>
        </div>
      </div>
      <!-- 圖書列表  end-->

      <van-popup v-model="showPicker"
                 round
                 position="bottom">
        <van-picker show-toolbar
                    :columns="list"
                    @cancel="showPicker = false"
                    @confirm="onConfirm"
                    :confirm-button-text="$t('app.home_sure')"
                    :cancel-button-text="$t('app.home_cancel')" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NavgationBar from "@c/currency/NavigationBarCustom";
import base from "../api/base"; // 导入接口域名列表
import { Toast } from "vant";
import { i18n, vantLocales, app } from "../lang";


export default {
  name: "bims",
  components: {
    NavgationBar
  },
  data: function () {
    return {
      isShowTips:false,
      tips_content:"",
      isComponent: "home",
      locationTitle: 0,
      shopId: null,
      showPicker: false,
      sale_machine_name: "",
      selectIndex: 0,
      // sold_img: require("@img/ibms_sold_out@2x.png"),
      lang: window.localStorage.getItem("lang"),
      loc_fonts: [
        { title: "繁体中文", type: "mo" },
        { title: "简体中文", type: "zh" },
        { title: "English", type: "en" },
        { title: "Português", type: "po" }
      ],
      addrs: [],
      list: [],
      address: "",
      arrList: [],
      isLocale: true,
      localeFont: "繁体中文",
      data: {},
    };
  },

  methods: {
     initLang(){
        var lang = this.$utils.getUrlKey('lang');
        if(lang!=null){
            var index = 0;
            switch(lang){
              case "mo":
                index = 0;
                break
                case 'zh':
                index = 1;
                break
                case 'en':
                index = 2;
                break
                case 'po':
                index = 3;
                break
            }
            this.onConfirm('',index)
        }
     },
    loadDataList() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true
      });
      this.$api.home
        .soldMachineList(this.shopId)
        .then(res => {
          debugger;
          var data = res.data.data;
          debugger;
          var arrList = [];
          if (data) {
            var image = data.map(obj => {
              var url =
                window.configUrl.baseURL + "/mbs/api/item/" + obj.itemid + "/file?type=" + 0;

              obj.photo_url = url;

              arrList.push(obj);
            });
          }
          //
          this.arrList = arrList;
        })
        .catch(error => { });
    },
    loadData() {

      this.setLocalLang();

      var that = this;
      this.$api.home
        .bookMenuList()
        .then(res => {
          debugger;
          var data = res.data.data;
          var lang = window.localStorage.getItem("lang");
          var name;
          if (lang.indexOf("zh") != -1) {
            name = "全部售卖机";
          } else if (lang.indexOf("en") != -1) {
            name = "Total of vending machines";
          } else if (lang.indexOf("po") != -1) {
            name = "Todas as máquinas de venda";
          } else {
            name = "全部售賣機";
          }

          var dict = {
            desc: "--",
            name: name,
            shopcode: "",
            shopid: null,
            addr: ""
          };
          var array = [];
          array.push(dict);
          for (var index in data) {
            var item = data[index];
            array.push(item);
          }

          this.data = array;
          var item = data[0];

          if (that.shopId) {
            data.forEach(item => {
              if (that.shopId == item.shopid) {
                this.address = item.addr;
                this.sale_machine_name = item.name;
              }
            });
          } else {
            //地址  id
          }

          var locations = this.data.map(obj => {
            return obj.name;
          });
          this.locations = locations;

          var addrs = data.map(obj => {
            return obj.addr;
          });
          this.addrs = addrs;
        })
        .catch(error => {
          console.log(error);
        });
    },
    goSearch() {
      this.$router.push({
        path: "/search",
        query: { routerType: "push" }
      });
    },

    openBookDetail(itemId) {
      debugger;
      this.$router.push({
        path: "/bookdetail",
        query: { routerType: "push", itemId: itemId, isFromHome: true }
      });
    },
    onConfirm(value, index) {
      debugger;
      this.showPicker = false;
      if (this.isLocale) {
        this.selectIndex = index;

        this.localeFont = this.loc_fonts[index].title;
        var local_text = this.loc_fonts[index].type;
        vantLocales(local_text);

        window.localStorage.setItem("lang", local_text);
      } else {
        debugger;
        var lang = window.localStorage.getItem("lang");
        if (index == 0) {
          if (lang.indexOf("zh") != -1) {
            this.sale_machine_name = "全部售卖机";
          } else if (lang.indexOf("en") != -1) {
            this.sale_machine_name = "Total of vending machines";
          } else if (lang.indexOf("po") != -1) {
            this.sale_machine_name = "Todas as máquinas de venda";
          } else {
            this.sale_machine_name = "全部售賣機";
          }
        } else {
          this.sale_machine_name = value;
        }

        var selectItem = this.data[index];
        this.address = selectItem["addr"];
        this.shopId = selectItem["shopid"];
      }
      this.loadDataList();
      if (this.isLocale) {
        this.loadData();
      }
      this.setTipsContent();
    },
    selectBookLoaction() {
      this.showPicker = true;
      this.list = this.locations;
      this.isLocale = false;
    },
    changeText() {
      this.showPicker = true;
      this.isLocale = true;
      var arrays = [];
      var loc_fonts = this.loc_fonts.map(obj => {
        return obj.title;
      });
      this.list = loc_fonts;
    },
    setLocalLang() {
      var lang = window.localStorage.getItem("lang");
      if (lang.indexOf("zh") != -1) {
        this.localeFont = "简体中文";
      } else if (lang.indexOf("en") != -1) {
        this.localeFont = "English";
      } else if (lang.indexOf("po") != -1) {
        this.localeFont = "Português";
      } else {
        this.localeFont = "繁体中文";
      }
    },
    checkAnnouncementStatus() {
      const now = new Date();
      // 注意：月份在 Date 构造函数中如果是字符串格式 'YYYY-MM-DD' 则无需减1，
      // 但为了清晰和避免时区问题，推荐使用 ISO 格式字符串或明确指定参数。
      // 这里使用标准日期字符串解析，确保时区一致（通常按本地时间或UTC，视后端需求而定，此处按本地时间处理）
      const startTime = new Date('2026-06-10T00:00:00');
      const endTime = new Date('2026-06-13T17:00:00');

      if (now > startTime && now < endTime) {
        this.isShowTips = true;
      } else {
        this.isShowTips = false;
      }
    },
    getTipsContent(){
       var lang = window.localStorage.getItem("lang");
          var tipsContent;
          if (lang.indexOf("zh") != -1) {
            tipsContent = "因系统升级，售卖机服务将於2026年6月12日 17:00至2026年6月13日 17:00暂停服务。";
          } else if (lang.indexOf("en") != -1) {
            tipsContent = "Due to system upgrades, vending machine service will be suspended from 17:00 on 12 June 2026 to 17:00 on 13 June 2026.";
          } else if (lang.indexOf("po") != -1) {
            tipsContent = "Devido à actualização do sistema, os serviços das máquinas de venda estarão suspensos no período entre 17:00 horas do dia 12 de Junho de 2026 e 17:00 horas do dia 13 de Junho de 2026.";
          } else {
            tipsContent = "因系統升級，售賣機服務將於2026年6月12日 17:00至2026年6月13日 17:00暫停服務。";
          }
          return tipsContent;
    },
    setTipsContent(){
      var tipsContent = this.getTipsContent();
     this.tips_content = tipsContent;
     this.checkAnnouncementStatus();
    }
  },
  created() {
    var shopid = this.$route.query.shopId;
    this.shopId = shopid ? shopid : null;
    this.initLang();
    setTimeout(() => {
      this.loadData();
      this.loadDataList();
    }, 2000);
  },
  mounted() {
     this.setLocalLang();
     this.setTipsContent();
     var that = this;
    this.$eventBus.$on("updateSoldMachineList", function (shopId) {
      that.shopId = shopId;

      that.loadData();
      that.loadDataList();
    });
  },
  destroyed() {
    this.$eventBus.$off("updateSoldMachineList");
  }
};
</script>

<style lang="scss" scoped>
.announcement-box{
   background-color: yellow;
    padding: 10px;
    color:red;
   font-size:20px;
   text-align: left;
}
.header-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(0deg, #269ca8 0%, #6ac6ba 100%);
  height: 54px;
  z-index: 9999;
}

.header-left-wrapper {
  display: flex;
  margin-left: 10px;
  // flex: 1;
}
.main-wrapper {
  width: 100%;
}
.header-left {
  font-weight: bold;
  color: #ffffff;
  font-size: 15px;
}

.header-right-wrapper {
  display: flex;
  flex-direction: row;
  // flex: 1;
  justify-content: center;
  align-items: center;
}

.header-right-item-left {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px 0px 0px 10px;
  height: 30px;
}
.book-title-maxHeight {
  height: 18px;
}
.header-right-wrapper-item {
  display: flex;
  flex-direction: row;
}
.header-right-item-right {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;

  border: 1px solid #ffffff;
  border-radius: 15px;
  margin-left: 5px;
  margin-right: 10px;
  padding: 0 5px;
}

.header-item-text {
  color: white;
  font-size: 13px;
}

.down-arrow {
  display: flex;
  width: 0px;
  height: 0px;
  border-width: 5px;
  border-style: solid;
  margin-top: 5px;
  margin-left: 1px;
  border-color: white transparent transparent transparent;
}

.down-address-arrow {
  display: flex;
  width: 0px;
  height: 0px;
  border-width: 5px;
  border-style: solid;
  margin-top: 5px;
  margin-left: 1px;
  border-color: #24a7b3 transparent transparent transparent;
}
// .down-arrow {
//   width: 7px;
//   height: 7px;
//   border-left: 2px solid white;
//   border-bottom: 2px solid white;
//   transform: rotate(-45deg);
// }

.location-bg {
  background: white;
  padding: 15px;
  margin-top: 54px;
}
.location-wrapper {
  display: flex;
  flex-direction: column;
  background-color: white;
  height: 60px;
  justify-content: center;
  padding-left: 5px;
}
.location-title-view {
  height: 30px;
  display: flex;
  align-items: center;
  background: #ffffff;
  border-left: 3px solid #24a7b3;
  padding-left: 5px;
  padding-right: 5px;
}
.location-top-view {
  border-top: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
  border-bottom: 0.5px solid #cccccc;
  border-radius: 3px 3px 0px 0px;
  display: flex;
  justify-content: space-between;
}
.location-bottom-view {
  border-right: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
  border-radius: 0px 0px 3px 3px;
}
.line-view {
  width: 100%;
  height: 3px;
  color: #cccccc;
}

.location-title-text {
  font-size: 13px;
  color: #24a7b3;
}

.location-desc-text {
  font-size: 11px;
  color: #4d4d4d;
}

// 圖片列表 start

.book-list-wrapper {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  position: relative;
}

.book-list-wrapper-item {
  display: flex;
  flex-direction: row;
  background-color: white;
  z-index: 888;
  font-size: 14px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
}
.van-divider {
  margin: 0.5px 0;
}
.book-left {
  margin-top: 10px;
  display: flex;
  width: 70px;
  height: 100px;
}

.book-right {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 10px;
  z-index: 888;
}
.book-title-text {
  color: #000000;
  font-size: 14px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  flex: 1;
}

.book-desc-wrapper {
  margin-top: 10px;
}
.book-desc-item {
  font-size: 13px;
  color: #ababab;
  padding: 3px 0px;
  display: flex;
  line-height: 15px;
}
.book-desc-item-left {
  width: 70px;
  font-size: 13px;
}
.book-desc-item-last {
  font-size: 13px;
  color: #ababab;
  padding: 3px 0px;
  display: flex;
  line-height: 15px;
  align-items: center;
  justify-content: space-between;
}
.book-desc-item-right {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.book-desc-item-content {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.book-desc-item-content-left {
  display: flex;
  flex: 1;
}

.book-desc-item-content-right {
  width: 100px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.book-desc-item-content-right-currency {
  font-size: 13px;
  margin-top: 5px;
  color: #4d4d4d;
}

.book-desc-item-content-right-amount {
  font-size: 20px;
  color: #24a7b3;
  font-weight: 500;
}
// .header-search-item {
//   display: flex;
//   flex: 2;
//   background: rgba(255, 255, 255, 0.2);
//   border-radius: 16px;
//   height: 30px;
//   width: 142px;
//   align-items: center;
// }

.header-input-item {
  display: flex;
  // flex: 1;
}

// 圖片列表 end
</style>
